export default "./dist/stdassets/images/icons/buffer.png";